<template>
  <div class="lb">
    <div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope14',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },

  data() {
    return {
      title: '基本柱状图-scope14',
      timer: null,
      defaultdata: [
        { value1: '数据一', value2: "31", value3: '台' },
        { value1: '数据二', value2: "44" },
        { value1: '数据三', value2: "122" },
        { value1: '数据四', value2: "47" },
        { value1: '数据五', value2: "109" },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
        { name: '单位', key: 'value3' },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
          let vlist = Object.keys(item)
          let isdata = false
          vlist.forEach(del => {
            if (item[del] == undefined) {
              item[del] = ''
            } else if (del && item[del]) {
              isdata = true
            }
          })
          if (vlist.length && isdata) return item
        })
        this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let unit = this.defaultdata[0].value3
      let vdata = this.defaultdata.map((item) => {
        return {
          name: item.value1,
          value: +item.value2,
        };
      });
      const xAxis = this.defaultdata.map((item) => {
        return item.value1;
      });
      // console.log(vdata,xAxis,numA,"abccc");

      const percent = (7 / xAxis.length) * 100;
      let zoom = [
        {
          id: 'scope14', // 唯一的id
          type: 'slider',
          moveHandleSize: 0,
          showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
            show: false,
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          selectedDataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "transparent",
          fillerColor: "rgba(0,0,0,.2)",
          borderColor: "transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        title: [
          {
            text: `单位：${unit}`,
            top: "0",
            left: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
              width: 80,
              overflow: 'truncate'
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "5px",
          right: "10px",
          bottom: "0px",
          top: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: vdata.map((item) => item.name),
          axisLabel: {
            interval: 0,
            width: 50,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            formatter: function (value) {
              return value
            },
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitNumber: 4,
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            smooth: true,
            stack: "Total",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0182fc", // 0% 处的颜色
                    },
                    {
                      offset: 0.8,
                      color: "#0182fc", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#08315f", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            symbolSize: 0,
            label: {
              show: false,
              position: "top",
              textStyle: {
                //设置文本样式
                color: "#0A79F6",
              },
            },
            data: vdata,
            barWidth: 15,
            barGap: "40%",
          },
        ],
        dataZoom: xAxis.length > 7 ? zoom : [],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>